// Ported from the Polaris kit: src/product/components/table-pin.js, by hand (the porter takes .vue files).
// Change the design in the kit first. Hand changes (phase 9.2): `right-0` → `end-0` (logical, RTL), and the kit's
// `--card`/`--muted` read as the prefixed `--polaris-*` tokens.
// The last column of a list holds the row action. It stays pinned to the end edge while the table scrolls
// sideways, so the action is never out of reach on a narrow screen or in a table with many columns.
// The pinned cell paints the surface behind it (pages and cards share `--card`) and follows the row's own hover
// tint (the registry row is `hover:bg-muted/50`), so no seam shows. Put `pinnedRow` on the row, `pinnedCell` on the cell.
export const pinnedRow = 'group/row';
export const pinnedCell =
  'sticky end-0 bg-polaris-card transition-colors group-hover/row:bg-[color-mix(in_srgb,var(--polaris-muted)_50%,var(--polaris-card))]';
